module.exports = __webpack_public_path__ + "img/DE00932.deb01ede.png";